import { Link, Typography } from "@mui/material";
import { useMicrospecThemeLanguageContext } from "../../Themes";

const Copyrights = (props) => {
    const { localizationProvider } = useMicrospecThemeLanguageContext();
    const microspec = localizationProvider.translateByType({
        type: "Internal",
        text: 'microspec'
    });
    const copyrightsReserved = localizationProvider.translateByType({
        type: "Internal",
        text: 'copyrightsReserved'
    });
    const copyright = ` ${copyrightsReserved} © ${new Date().getFullYear()} `;
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            <Link color="inherit" href="http://microspec.io">{microspec}</Link> {copyright}
        </Typography>
    );
}

export default Copyrights